import { render } from "./EventCard.vue?vue&type=template&id=1ff5369c&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=1ff5369c&scoped=true&lang=css"

import exportComponent from "/Users/alain/Documents/realWorldVue/real-world-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff5369c"]])

export default __exports__